module.exports = __webpack_public_path__ + "img/flag.2fd2b63f.svg";